export default {
  artwork: () => import("/Users/kerem/Documents/repo/atelier-materica-mente/layouts/artwork.vue").then(m => m.default || m),
  default: () => import("/Users/kerem/Documents/repo/atelier-materica-mente/layouts/default.vue").then(m => m.default || m),
  error: () => import("/Users/kerem/Documents/repo/atelier-materica-mente/layouts/error.vue").then(m => m.default || m)
}